import { render, staticRenderFns } from "./SeminarOrderListItem.vue?vue&type=template&id=ee4b0956&"
import script from "./SeminarOrderListItem.vue?vue&type=script&lang=js&"
export * from "./SeminarOrderListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports